<div class="d-flex flex-column gap-3" data-testid="payments-panel">
  <div class="d-flex flex-column gap-1">
    <h3 class="av-section-title m-0">{{ 'backoffice.billing.payments.title' | translate }}</h3>
    <p class="av-meta m-0" data-testid="payments-actions-note">{{ 'backoffice.billing.payments.actions_note' | translate }}</p>
    <a
      class="av-btn text-decoration-none align-self-start"
      [routerLink]="['/organizations', organizationId(), 'billing']"
      data-testid="billing-documents-link"
    >
      <mat-icon aria-hidden="true">receipt_long</mat-icon>
      <span>{{ 'backoffice.billing.documents.link' | translate }}</span>
    </a>
  </div>

  @if (facade.attention(); as attention) {
    <section class="attention-card p-3 d-flex flex-column gap-2" data-testid="payments-attention">
      <span class="cell-strong">{{ 'backoffice.billing.attention.title' | translate }}</span>

      <div class="d-flex flex-wrap align-items-center gap-2">
        <av-status-chip
          [label]="
            'backoffice.billing.attention.open_invoices_chip'
              | translate: { count: attention.open_invoice_count }
          "
          [tone]="attention.open_invoice_count > 0 ? 'warning' : 'neutral'"
        ></av-status-chip>

        <av-status-chip
          [label]="
            'backoffice.billing.attention.failed_payments_chip'
              | translate: { count: attention.failed_payment_count }
          "
          [tone]="attention.failed_payment_count > 0 ? 'danger' : 'neutral'"
        ></av-status-chip>
      </div>

      <p class="av-meta m-0">{{
          (attention.in_dunning
            ? 'backoffice.billing.attention.in_dunning'
            : 'backoffice.billing.attention.clear'
          ) | translate
        }}</p>

      @if (!attention.is_owned) {
        <div class="av-banner p-2 d-flex align-items-start gap-2">
          <mat-icon aria-hidden="true">error_outline</mat-icon>
          <span>{{ 'backoffice.billing.attention.not_owned' | translate }}</span>
        </div>
      }
    </section>
  }

  @switch (facade.paymentsState()) {
    @case ('error') {
      <av-empty-state
        icon="error_outline"
        [title]="'backoffice.billing.payments.error_title' | translate"
        [message]="'backoffice.billing.payments.error_message' | translate"
      ></av-empty-state>
    }
    @case ('ready') {
      <div class="filter-row d-flex flex-wrap align-items-end gap-2">
        <label class="d-flex flex-column gap-1" for="payment-status">
          <span class="av-meta">{{ 'backoffice.billing.payments.filters.status' | translate }}</span>
          <select
            id="payment-status"
            class="av-field"
            [value]="facade.paymentStatus()"
            (change)="filterStatus($any($event.target).value)"
          >
            <option value="">{{ 'backoffice.billing.payments.filters.any_status' | translate }}</option>
            @for (option of statusOptions; track option) {
              <option [value]="option">{{ statusLabelKeys[option] | translate }}</option>
            }
          </select>
        </label>
      </div>

      @if (isEmpty()) {
        <av-empty-state
          icon="payments"
          [title]="
            (facade.paymentStatus()
              ? 'backoffice.billing.payments.filtered_empty_title'
              : 'backoffice.billing.payments.empty_title'
            ) | translate
          "
          [message]="
            (facade.paymentStatus()
              ? 'backoffice.billing.payments.filtered_empty_message'
              : 'backoffice.billing.payments.empty_message'
            ) | translate
          "
        ></av-empty-state>
      } @else {
        <div class="table-scroll">
          <table class="av-table w-100" data-testid="payment-table">
            <thead>
              <tr>
                <th scope="col">{{ 'backoffice.billing.payments.table.payment' | translate }}</th>
                <th scope="col">{{ 'backoffice.billing.payments.table.status' | translate }}</th>
                <th scope="col" class="text-end">{{ 'backoffice.billing.payments.table.amount' | translate }}</th>
                <th scope="col">{{ 'backoffice.billing.payments.table.invoice' | translate }}</th>
                <th scope="col">{{ 'backoffice.billing.payments.table.failure' | translate }}</th>
                <th scope="col">{{ 'backoffice.billing.payments.table.recorded' | translate }}</th>
              </tr>
            </thead>

            <tbody>
              @for (payment of facade.payments(); track payment.id) {
                <tr>
                  <td class="av-source">{{ payment.stripe_payment_intent_id || unresolved }}</td>

                  <td>
                    <av-status-chip
                      [label]="payment.statusLabelKey | translate"
                      [tone]="payment.statusTone"
                    ></av-status-chip>
                  </td>

                  <td class="text-end">
                    {{ payment.amount === null ? unresolved : (payment.amount | number: '1.2-2') }}
                    {{ payment.currency || '' }}
                  </td>

                  <td class="av-source">{{ payment.invoice?.stripe_invoice_id || unresolved }}</td>

                  <td class="cell-muted">
                    {{ payment.failure_message || payment.failure_code || unresolved }}
                  </td>

                  <td class="cell-muted">
                    {{ payment.created_at ? (payment.created_at | date: dateTimeFormat) : unresolved }}
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>

        <av-paginator
          [page]="facade.paymentPage()"
          [pageSize]="facade.pageSize()"
          [total]="facade.paymentTotal()"
          (pageChange)="goToPage($event)"
          (pageSizeChange)="changePageSize($event)"
        ></av-paginator>
      }
    }
    @default {
      <av-empty-state
        icon="hourglass_empty"
        [title]="'backoffice.billing.payments.loading_title' | translate"
        [message]="'backoffice.billing.payments.loading_message' | translate"
      ></av-empty-state>
    }
  }
</div>
